import { DaysOfWeek } from './enums';
import { User } from './user';
import { IContact } from './contact';
import { IAttachment } from './attachment';
import { Moment } from 'moment';

export interface IFrequency {
  duration: number;
  dayOfWeek: DaysOfWeek;
}
export interface IAgreementSupportItem {
  NDISName: string;
  NDISNumber: string;
  description: string;
  amountExclGst: number;
  frequency: IFrequency[];
  location: string;
}

export enum AgreementStatus {
  Draft = 'Draft',
  Completed = 'Completed',
  All = 'All',
  // Expired = 'Expired',
}

export interface IAgreement {
  id: string;
  user: User;
  idUser: string;
  userResponsibilities: string[];
  contact: IContact;
  idContact: string;
  contactResponsibilities: string[];
  code: string;
  agreementStatus: string;
  startDate: Moment;
  endDate: Moment;
  reviewDate: Moment;
  amendmentDays: number;
  sendInvoicesAfter: number;
  supportItems: IAgreementSupportItem[];
  canChargeCancellation: string;
  attachments: IAttachment[];
  completedAt: Moment;

  expanded: boolean;
}
